export default __webpack_public_path__ + "assets/images/Landing_page_logo2.5ce46103.svg";